// extracted by mini-css-extract-plugin
export default {"dark":"header_dark__-9aw1","dark__inner":"header_dark__inner__aZDYt","light":"header_light__Y96vb","light__inner":"header_light__inner__GdHaa"};